import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import IncentivePerformance from '../common/store-performances/incentive-performance';
import { destandard } from '../../utils/commonFunctions';
import './style.css';
import { connect } from 'react-redux';

class AccountManagerPerformance extends Component {
  render() {
    const { incentivePerformances } = this.props;

    if (!incentivePerformances) {
      return null;
    }

    return (
      <div>
        <div className="incentive-performances">
          <Panel>
            {incentivePerformances.incentives.map((incentive) =>
              <IncentivePerformance
                key={incentive.id}
                incentive={destandard({...incentive.attributes})}
                date={incentivePerformances.correctToDate}
                outlet_id=""
                isStoreButtonHide
              />
            )}
          </Panel>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    incentivePerformances: state.incentivePerformances,
  };
};

export default connect(mapStateToProps)(AccountManagerPerformance);



// WEBPACK FOOTER //
// ./src/components/store-performance/account-manager-performance.jsx